import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Service radius in miles from customer.
 */
export const schema = z.union([z.number(), z.string()]);

export type ServiceableRadiusMiles = z.infer<typeof schema>;

export const definition = define({
  key: 'serviceable_radius_miles',
  schema,
  label: 'HopDrive Service Radius',
  description:
    'Used to validate move eligibility within the radius for clients who pre-verify using our API. For more information, see our API documentation here.',
  warning: 'If set, must enable pickup or delivery verification.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.SERVICE_RADIUS.key,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
});
